import { createSelector } from '@reduxjs/toolkit';
import { STTimeLineChartData } from '../../../pages/AuthenticatedPages/Manager/ManagerPerformances/monitoring.model';
import { CommanderMonitoringFilterLogicalObject } from '../../../pages/AuthenticatedPages/Manager/ManagerPerformances/util/filter.model';
import { RootState } from '../../store.model';

const getAllDevicesIdsByMode = (
  state: RootState,
  props: { deviceId?: string }
) => (props.deviceId ? [props.deviceId] : []);

export const getDictionarySensorData = (state: RootState) =>
  state.monitoring.dicSensordata;
export const getDictionaryDigitalChannels = (state: RootState) =>
  state.monitoring.dicDigitalChannels;

export const getMonitoringError = (state: RootState) => state.monitoring.error;
export const getMonitoringLoading = (state: RootState) =>
  state.monitoring.loading;
interface OptionsNavProps {
  controlUnitId?: string;
  groupId?: string;
  deviceId?: string;
}
export interface FilterStoredProps extends OptionsNavProps {
  type: 'events' | 'channels';
}
export const getPatchFilter = (props: FilterStoredProps) => {
  const {
    controlUnitId = 'NO_CONTROL_UNIT',
    deviceId = 'NO_DEVICE',
    groupId = 'NO_GROUP',
    type,
  } = props;

  return `HistoryFilter-${type}-${groupId}-${deviceId}-${controlUnitId}`;
};
export const getFilterStored = (state: RootState, props: FilterStoredProps) => {
  const path = getPatchFilter(props);
  const filter = state.features.filters[path];
  return typeof filter === 'string'
    ? (JSON.parse(filter) as CommanderMonitoringFilterLogicalObject)
    : undefined;
};

export const getMetricsSelector = createSelector(
  [
    getAllDevicesIdsByMode,
    getDictionarySensorData,
    getDictionaryDigitalChannels,
  ],
  (devicesId, dictionarySensorData, dictionaryDigitalChannels) => ({
    sensordata: dictionarySensorData[devicesId[0] || ''] || [],
    digitalChannels: dictionaryDigitalChannels[devicesId[0] || ''] || [],
  })
);

export const getSensordataSelector = createSelector(
  [getDictionarySensorData, getAllDevicesIdsByMode],
  (dictionarySensorData, devicesIds) => {
    return (
      devicesIds.flatMap(
        (deviceId) => dictionarySensorData[deviceId || ''] ?? []
      ) || []
    );
  }
);
export const getDigitalChannelDataSelector = createSelector(
  [getDictionaryDigitalChannels, getAllDevicesIdsByMode],
  (dictionaryDigitalChannels, devicesIds) => {
    return devicesIds.reduce(
      (acc, deviceId) => ({
        ...acc,
        ...dictionaryDigitalChannels[deviceId || ''],
      }),
      {} as STTimeLineChartData
    );
  }
);

export const getMetricsSelectorGroup = createSelector(
  [getSensordataSelector, getDigitalChannelDataSelector],
  (sensordata, digitalChannels) => {
    return {
      sensordata,
      digitalChannels,
    };
  }
);

export const getCommanderDataSelector = createSelector(
  [
    (state: RootState, props: { commanderId?: string }) => props.commanderId,
    (state: RootState) => state.monitoring.dicCommanderData,
  ],
  (commanderId, dicCommanderData) => {
    return dicCommanderData[commanderId || ''] ?? [];
  }
);
